export const environment = {
  production: false,
  title: 'Production Environment',
  apiURL: 'https://gepdecapi.cfcsitservices.co.in',
  b2bApiUrl: 'https://gepdecapi.cfcsitservices.co.in/api/v1/B2B/admin',
  b2bApiUrl2: 'https://gepdecapi.cfcsitservices.co.in/api/v1/B2B',
  salesApiURL: 'https://gepdecapi.cfcsitservices.co.in/api/v1/Sales/Admin',
  imageUrl: 'https://gepdecapi.cfcsitservices.co.in/images',
  blogImageUrl: 'https://gepdecapi.cfcsitservices.co.in/blog',
  bannerImageUrl: 'https://gepdecapi.cfcsitservices.co.in/banner',
  thumbNailUrl: 'https://gepdecapi.cfcsitservices.co.in/thumbnail',
};
